import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { ImPhone } from "react-icons/im";
import {
  MdLocationPin,
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
  MdStar,
} from "react-icons/md";

import { FavouriteRestaurant } from "../../../api/types/account.type";
import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { useRestaurants } from "../../../store/restaurants.context";
import { useUser } from "../../../store/user.context";
import { translate } from "../../../utils/translate";
import AddButton from "../../ui/button/AddButton";
import DarkButton from "../../ui/button/DarkButton";
import Button from "../../ui/button/SimpleButton";
import classes from "./favouriteLocation.module.scss";

const Restaurants = dynamic(() => import("./Restaurants"), { ssr: false });

const FavouriteLocation = () => {
  const { user } = useUser();
  const { restaurants } = useRestaurants();
  const [dropdownOpened, setDropdownOpened] = useState<boolean>(false);
  const [favRestaurant, setFavRestaurant] = useState<FavouriteRestaurant>();

  const { language } = useLanguage();

  const [openRestaurantsMap, setOpenRestaurantsMap] = useState<boolean>(false);

  useEffect(() => {
    if (user?.current_restaurant) {
      const favoriteRestaurant = restaurants.find(
        (restaurant) => restaurant.id === parseInt(user?.current_restaurant)
      );
      if (favoriteRestaurant) {
        const time = favoriteRestaurant?.opening_hours
          ? favoriteRestaurant.opening_hours[0].from_hour
          : "N/A";
        setFavRestaurant({
          ...favoriteRestaurant,
          time,
          name: favoriteRestaurant?.name.substring(10),
        });
      }
    }
  }, [user?.current_restaurant, restaurants]);

  return (
    <div className={classes.mainContainer}>
      <h2 className={classes.mainTitle}>
        {translate(translationsContent, "favoriteRestaurant", language)}
      </h2>
      {user?.current_restaurant ? (
        <>
          {favRestaurant && (
            <div className={classes.container}>
              <div className={classes.title}>
                <MdStar className={classes.icon}></MdStar>
                <p>{favRestaurant?.name}</p>
              </div>
              <div className={classes.details}>
                <p>
                  <MdLocationPin className={classes.icon} />
                  {favRestaurant?.addresse}
                </p>
                <p>
                  <ImPhone className={classes.icon} />
                  {favRestaurant?.phone_number}
                </p>
              </div>
              <div className={classes.button}>
                <div className={classes.wideButton}>
                  <DarkButton
                    label={`${translate(
                      translationsContent,
                      "modifyButton",
                      language
                    )}`}
                    type="inverted"
                    onClick={() => {
                      setOpenRestaurantsMap(true);
                    }}
                  />
                </div>
                <div className={classes.narrowButton}>
                  <AddButton
                    color="white"
                    onClick={() => {
                      setOpenRestaurantsMap(true);
                    }}
                  />
                </div>
              </div>
              <div className={classes.openingHours}>
                <p
                  onClick={() => {
                    setDropdownOpened(!dropdownOpened);
                  }}
                >
                  {`${translate(translationsContent, "openUntil", language)} `}{" "}
                  {favRestaurant?.time}
                </p>
                <span className={classes.dropdownOpener}>
                  {dropdownOpened ? (
                    <>
                      <MdOutlineKeyboardArrowUp
                        onClick={() => {
                          setDropdownOpened(false);
                        }}
                      />
                      <div className={classes.dropdown}>
                        {favRestaurant?.opening_hours &&
                          favRestaurant.opening_hours.map((hours, i) => {
                            return (
                              <div
                                key={`favourite-location-time-slot-${i}`}
                                className={classes.timeSlot}
                              >
                                <span>{hours.weekday_display}</span>{" "}
                                <span>
                                  {hours.from_hour} / {hours.to_hour}
                                </span>
                              </div>
                            );
                          })}
                      </div>
                    </>
                  ) : (
                    <MdOutlineKeyboardArrowDown
                      onClick={() => {
                        setDropdownOpened(true);
                      }}
                    />
                  )}
                </span>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className={classes.noFavouriteContainer}>
          <p>
            {translate(
              translationsContent,
              "favoriteRestaurantContent",
              language
            )}
          </p>
          <div>
            <Button
              label={`${translate(
                translationsContent,
                "favoriteRestaurantButton",
                language
              )}`}
              onClick={() => {
                setOpenRestaurantsMap(true);
              }}
            />
          </div>
        </div>
      )}
      {openRestaurantsMap && (
        <div className={classes.map}>
          <Restaurants setRestaurantSelectionIsOpen={setOpenRestaurantsMap} />
        </div>
      )}
    </div>
  );
};

export default FavouriteLocation;
